import { render, staticRenderFns } from "./BdTableAgent.vue?vue&type=template&id=6998f478&scoped=true&"
import script from "./BdTableAgent.vue?vue&type=script&lang=js&"
export * from "./BdTableAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6998f478",
  null
  
)

export default component.exports